export const OrderStatus = {
  pending: "pending",
  processing: "processing",
  delivarying: "delivarying",
  completed: "completed",
  canseled: "canseled",
};
